export { default } from './ownerDocument';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/ownerDocument/index.js
// module id = 444
// module chunks = 25